export default "__VITE_ASSET__99d9d4e7__"